"use client";
import Image from "next/image";
import { HTMLAttributes, memo, useState } from "react";
import { PlayIcon } from "@heroicons/react/24/outline";

import cx from "@/utils/cx";

const Player = (
  props: {
    title: string;
    src: string;
    poster: string;
    className?: string;
    load?: "visible" | "idle";
    withSkin?: boolean;
  } & HTMLAttributes<HTMLVideoElement>
) => {
  const [isPlayerVisible, setIsPlayerVisible] = useState(false);
  if (!props.src) return null;

  if (!isPlayerVisible)
    return (
      <div
        id="player"
        className="relative w-full overflow-hidden shrink-0 aspect-video bg-black-600 rounded-md cursor-pointer group"
        onClick={() => setIsPlayerVisible(true)}
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 p-1.5 rounded-md opacity-80 group-hover:opacity-100 bg-black-600 bg-opacity-60 flex justify-center items-center">
          <PlayIcon className="w-12 h-12 md:w-16 md:h-16 text-gray-100 group-hover:text-white" />
        </div>
        <Image
          fill
          priority
          loading="eager"
          src={props.poster}
          alt={props.title}
          className="rounded-md object-cover"
          sizes="(max-width: 768px) 100vw, (max-width: 1024px) 600px, 600px"
        />
      </div>
    );

  return (
    <div className="video-container w-full shrink-0 rounded-md">
      <video
        autoPlay
        controls
        controlsList="nodownload"
        className={cx("w-full rounded-md", props.className)}
        preload={props.load === "idle" ? "none" : "metadata"}
        {...props}
      />
    </div>
  );
};

export default memo(Player);
